import { c as _c } from "react/compiler-runtime";
import MobileSettingsHeader from 'modules/funnels/funnel/components/mobile-settings-header';
import SplitTestActions from 'modules/funnels/funnel/components/split-tests-tab/split-test-actions';
import SplitTestHistory from 'modules/funnels/funnel/components/split-tests-tab/split-test-history';
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum';
import { useFunnelStepTests } from 'modules/funnels/funnel/hooks/use-funnel-step-tests';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React from 'react';
import { Loader } from 'shared/components/loader';
interface SplitTestsTabProps {
  funnelId: FunnelId;
  funnelStep: FunnelStepInterface | null;
}
function SplitTestsTab(t0) {
  const $ = _c(11);
  const {
    funnelId,
    funnelStep
  } = t0;
  const {
    splitTestData
  } = useFunnelStepTests(funnelStep?.id);
  if (!splitTestData || !funnelStep) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Loader className="mb-10 mt-10 flex scale-150 justify-center" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MobileSettingsHeader type={FunnelStepSettingTabsEnum.tests} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== funnelId || $[3] !== funnelStep || $[4] !== splitTestData) {
    t2 = <SplitTestActions funnelId={funnelId} funnelStep={funnelStep} data={splitTestData} />;
    $[2] = funnelId;
    $[3] = funnelStep;
    $[4] = splitTestData;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== funnelStep) {
    t3 = <SplitTestHistory funnelStep={funnelStep} />;
    $[6] = funnelStep;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="mb-10 flex flex-col gap-8 px-4 lg:px-0">{t1}{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
export default SplitTestsTab;